(function ($) {
  accordionItemMobileV1 = {
    formatter: $('.accordion-item-mobile-v1')
  };

  Drupal.behaviors.accordionItemMobileV1 = {
    get: function (key) {
      return accordionItemMobileV1[key];
    },

    set: function (key, val) {
      accordionItemMobileV1[key] = val;
    },

    attach: function (context, settings) {
      if ($('body').hasClass('device-mobile')) {
        var self = this;
        var formatter = self.get('formatter');

        formatter.each(function () {
          var thisFormatter = $(this);

          // Accordion Functionality
          thisFormatter.find('h3').off('click').on('click', function() {
            var $h3 = $(this);

            $h3.toggleClass('selected');
            $h3.parent().siblings().children('h3').removeClass('selected');
            $h3.parent().siblings().find('h3').next().hide();
            $(this).next().slideToggle(500, function () {
            // $('body, html').scrollTo($h3, {duration: 500, axis: "y"});
            });
          });
        });
      }
    }
  };
})(jQuery);
